import { useMemo } from 'react';
import { useDateFormatter } from '../useDateFormatter';

export const useDateFormat = (date: Date, format: Omit<Intl.DateTimeFormatOptions, 'timeZone'>) => {
    const formatter = useDateFormatter(format);
    const formattedDate = useMemo(() => {
        return formatter(date);
    }, [date, formatter]);
    return formattedDate;
};
